import { realBricksApi } from "../../utils/axiosInterceptors";


export const fetchTokenApi = async () => {
    const response = await realBricksApi.get(`/api/v1/user/plaid-link-token`);
    return response.data;
};

export const sendBankDetailApi = async (data) => {
    const response = await realBricksApi.post(`/api/v1/user/bank-funding-source`, data);
    return response.data;
};

export const verifyMicroDeposit = async (id = null) => {
    const response = await realBricksApi.post('/api/v1/user/verify-micro-deposit', { fundingSourceId: id?.toString() });
    return response.data;
}

export const manualVerifyMicroDeposit = async (data) => {
    const response = await realBricksApi.post('/api/v1/payment/manual-verify-micro-deposit', data)
    return response.data;
}

export const storePlaidError = async (data) => {
    const response = await realBricksApi.post('/api/v1/user/plaid-client-error',data)
    return response.data;
}